import { percentageFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { GenericProgressBarCell } from "app/components/React/Table/cells/GenericProgressBarCell";

export const PercentageBarCellRounded: FC<ITableCellProps> = ({ value, GAVerifiedIcon }) => {
    const hasValues = value?.length && ((value[0] || 0) > 0 || (value[1] || 0) > 0);
    const fillPercent = value && value[0] ? value[0] * 100 : 0;

    const leftValue = hasValues && percentageFilter()(value[0], 1) + "%";
    const rightValue = hasValues && percentageFilter()(value[1], 1) + "%";

    return (
        <GenericProgressBarCell value={{ leftValue, rightValue, fillPercent }}>{GAVerifiedIcon}</GenericProgressBarCell>
    );
};

PercentageBarCellRounded.displayName = "PercentageBarCellRounded";
